module.exports = __webpack_public_path__ + "img/DrugLicense.647badb6.jpg";